import * as React from 'react';

import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';

import {FacetPicker} from '../facet-picker';
import type {ReportFacet} from '../report-types';

import type {Stageset} from './types';

type Props = {
    onReportFacetChanged: (reportFacet: ReportFacet) => any;
    reportFacet: ReportFacet;
    selectedFunnelId: string | null | undefined;
    onStagesetChanged: (stageset: Stageset) => void;
    stagesets?: Stageset[];
    multipleFunnelEnabled: boolean;
};

export class FunnelReportDisplayTypeSelector extends React.Component<Props> {
    render() {
        return (
            <div className='ui-funnel-report__controls-container'>
                {this.props.multipleFunnelEnabled && this.props.stagesets ? (
                    <div className='stageset-selector'>
                        <SelectPickerGeneric
                            name='stageset_id'
                            value={this.props.stagesets.filter(
                                ({id}) => id === this.props.selectedFunnelId
                            )}
                            isClearable={false}
                            isSearchable={false}
                            labelKey='name'
                            valueKey='id'
                            options={this.props.stagesets}
                            onChange={this.props.onStagesetChanged}
                        />
                    </div>
                ) : null}

                <FacetPicker
                    facet={this.props.reportFacet}
                    onFacetChange={this.props.onReportFacetChanged}
                />
            </div>
        );
    }
}
